import Model, { attr } from '@ember-data/model';
import { arrayAttr, objectAttr } from 'eflex/decorators';
import { service } from '@ember/service';

export default class ConfigurationHistory extends Model {
  @attr('string') version;
  @attr('string') versionDateString;
  @attr('string') versionSequence;
  @attr('string') note;
  @attr('string') type;
  @attr('date') timestamp;
  @arrayAttr acknowledgedBy;
  @objectAttr location;
  @objectAttr user;

  @service intl;
  @service userRepo;
  @service currentUser;

  get stationId() {
    return this.location?.id ?? this.location?._id;
  }

  get station() {
    return this.store.peekRecord('station', this.stationId);
  }

  get needsToAcknowledge() {
    return this.userRepo.users.filter(user =>
      user.createdAt != null &&
      user.createdAt <= this.timestamp &&
      !this.acknowledgedBy.some(item => item.userName === user.userName),
    );
  }

  acknowledge(user) {
    if (!this.acknowledgedBy.some(item => item.userName === user.userName)) {
      this.acknowledgedBy.push(user.toFragment());
    }

    if (this.needsToAcknowledge.length === 0) {
      this.isActive = false;
    }
  }
}
